import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'deal-search-result.deal-label',
		defaultMessage: 'Deal',
		description: 'Deal subtype label',
	},
	closedOn: {
		id: 'deal-search-result.closed-on',
		defaultMessage: 'Closed on {date}',
		description: 'Date when the deal was closed',
	},
});
